module.exports = __webpack_public_path__ + "media/images/logos/courtsdesk-text-color-119x41-a1a1f7b90031e4cbf869eedf86373cbf.svg";